/**
 * The landing page: every form available to the signed-in user, one row each.
 *
 * "Available" is currently "every form in the registry" — the registry has no notion
 * of which client a form belongs to, so a client-specific form (CEL's, say) is listed
 * for everyone. Scoping forms per tenant belongs in `@portal/forms` and the BFF, not
 * here: this component renders whatever list it is handed.
 */
export function FormPicker({ forms, canSubmit, onChoose }) {
  return (
    <section className="card">
      <h1>Choose a request</h1>

      {forms.length === 0 ? (
        <p className="muted">No request forms are available to your account yet.</p>
      ) : (
        <p className="muted">Pick the form that matches what you need.</p>
      )}

      {!canSubmit && forms.length > 0 && (
        <p className="alert alert--warn" role="status">
          You can view these forms but your account does not have the Submitter role, so you cannot
          submit them.
        </p>
      )}

      <ul className="form-list">
        {forms.map((form) => (
          <li key={form.id}>
            <button type="button" className="form-choice" onClick={() => onChoose(form.id)}>
              <span className="form-choice__title">{form.title}</span>
              {form.description && <span className="form-choice__desc">{form.description}</span>}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
